<div fxLayout="column" class="w-100">
    <div fxLayoutAlign="start center" fxLayoutGap="3px">
        <span class="label mb-7p" i18n>Set privacy</span>
    </div>
    <mat-form-field appearance="fill" class="templates-select" fxFlex="0 0 100%">
        <mat-select placeholder="Select note privacy" i18n-placeholder [formControlName]="privacyControlName">
            <mat-option *ngFor="let option of privacyOptions" [value]="option.value">
                {{ option.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<!-- User search -->
<div class="input-wrapper default-note" fxLayout="column" *ngIf="parentForm.get(privacyControlName)?.value === 'users'">
    <span class="label" i18n>To</span>
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutGap.lt-md="10px">
        <mat-form-field
            *ngIf="selectedRecepientFilter.value === 'users'"
            class="small-field mt-1 users-rec-input"
            appearance="fill"
        >
            <input
                type="text"
                matInput
                #userRecieverInput
                i18n-placeholder
                placeholder="Search users"
                [formControl]="userCtrl"
                [matAutocomplete]="autoUser"
            />
            <mat-autocomplete #autoUser="matAutocomplete" (optionSelected)="selected(autoUser, $event, true)">
                <mat-option *ngFor="let user of userSearch$ | async" [value]="user">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon> {{ user.role_value | userRoleIcon }}</mat-icon>
                        <span>{{ user.name }}</span>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div fxLayout="column wrap">
        <mat-chip-list *ngIf="userRecipients.length" class="reci-chips mb-1" #chipList aria-label="Recievers selection">
            <mat-chip
                *ngFor="let recipient of userRecipients"
                (removed)="removeUser(recipient)"
                [selectable]="false"
                class="users-wrap"
                [ngClass]="{
                    'dark-blue-bg': recipient.role_value === 'user',
                    'green-bg': recipient.role_value !== 'user'
                }"
            >
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>{{ recipient.role_value | userRoleIcon }}</mat-icon>
                    <span>{{ recipient.fname }}</span>
                    <span> {{ recipient.lname }}</span>
                </div>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip></mat-chip-list
        >
    </div>
</div>
<!-- Group search -->
<div
    class="input-wrapper default-note"
    fxLayout="column"
    *ngIf="parentForm.get(privacyControlName)?.value === 'groups'"
>
    <span class="label" i18n>To</span>
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutGap.lt-md="10px">
        <mat-form-field class="small-field mt-1 groups-rec-input" appearance="fill">
            <input
                type="text"
                matInput
                #groupRecieverInput
                i18n-placeholder
                placeholder="Search groups"
                [formControl]="groupCtrl"
                [matAutocomplete]="autoGroup"
            />
            <mat-autocomplete #autoGroup="matAutocomplete" (optionSelected)="selected(autoGroup, $event, false)">
                <mat-option *ngFor="let group of groupSearch$ | async" [value]="group">
                    {{ group.name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div fxLayout="column wrap">
        <mat-chip-list
            *ngIf="groupRecipients.length"
            class="reci-chips mb-1"
            #chipList
            aria-label="Recievers selection"
        >
            <mat-chip
                *ngFor="let recipient of groupRecipients"
                (removed)="removeGroup(recipient)"
                [selectable]="false"
                class="groups-wrap"
            >
                <div fxLayout="row" class="groups" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>groups</mat-icon>
                    <span>{{ recipient.name }}</span>
                </div>

                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip></mat-chip-list
        >
    </div>
</div>
